var exports = {
  "kL": "xfd349460--42e346--container",
  "DD": "xfd349460--42e346--title",
  "V0": "xfd349460--42e346--sections",
  "p_": "xfd349460--42e346--list",
  "AS": "xfd349460--42e346--item",
  "Yq": "xfd349460--42e346--reviews",
  "qr": "xfd349460--42e346--footer",
};

module.exports = exports;
